import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import {
  CASH_DISCOUNT_CUSTOMERS_REPORT_LOADINGS,
  reportCashDiscountCustomersTypes,
} from "redux/reducers/Reports/reportCashDiscountCustomers/types";

const { SET_CASH_DISCOUNT_CUSTOMERS_REPORT_FILTERS } = reportCashDiscountCustomersTypes;
const { GET_REPORT } = CASH_DISCOUNT_CUSTOMERS_REPORT_LOADINGS;

export const getCashDiscountCustomersReportAction = (
  { station, isPdf }
) => async (dispatch, getState) => {
  const token = getState().login.token || localStorage.getItem("crm-user");
  dispatch(startRequestComp(GET_REPORT));
  try {
    const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/cash-discount-report/${station.id}`;
    const res = await axios.get(url, {
      headers: { authorization: token },
      responseType: "blob",
      params: { pdf: isPdf },
    });

    const format = isPdf ? "pdf" : "xlsx";
    saveAs(res.data, `Reporte_clientes_contado_descuento_${station.name}.${format}`);
    dispatch(setSnackbar("Reporte descargado con éxito", "success"));
  } catch (err) {
    dispatch(setSnackbar(await getErrorBlob(err)));
  } finally {
    dispatch(stopRequestComp(GET_REPORT));
  }
};

export const setCashDiscountCustomersReportFilters = (key = "", value) => ({
  type: SET_CASH_DISCOUNT_CUSTOMERS_REPORT_FILTERS,
  payload: { key, value }
});
